import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui";

export default class SliderModule {
    constructor(dom) {
        this.dom = dom;
        this.sliderM = this.dom.querySelectorAll(".slider-module");

        // const slideritem = this.dom.querySelector(".slider-module");
        //   for (let slider of this.sliders) {
        //     this.initSlider(slider);
        //   }
        // }

        // initSlider(){
        
        const lazyImages = this.dom.querySelectorAll('img.lazy-fade');

        lazyImages.forEach(img => {
            if (img.complete) {
                img.classList.add('loaded');
            } else {
                img.addEventListener('load', () => {
                    img.classList.add('loaded');
                });
            }
        });

        this.sliderM.forEach((slider) => {
            const slug = slider.dataset.slug;
            const type = slider.dataset.type;

            let slidesPerView = 1.2;
            let slidesPerView_968 = "auto";
            
            switch (type) {
                case "small":
                    slidesPerView = 2.5;
                    slidesPerView_968 = "auto";
                    break;

            }

            new Swiper(slider, {
                lazy: true,
                slidesPerView: slidesPerView,
                spaceBetween: 10,
                // freeMode: true,
                breakpoints: {
                    968: {
                        // slidesPerView: 2.65,
                        slidesPerView: slidesPerView_968,
                        freeMode: false,
                        spaceBetween: 10,
                    },
                },
                navigation: {
                    nextEl: slider.querySelector(
                        ".slider-module--btn.swiper-button-next"
                    ),
                    prevEl: slider.querySelector(
                        ".slider-module--btn.swiper-button-prev"
                    ),
                },
            });

            Fancybox.bind(`[data-fancybox="${slug}"]`, {
                Toolbar: {
                    display: {
                        left: [],
                        middle: [],
                        right: ["close"],
                    },
                },
                Thumbs: {
                    type: "",
                },
                Images: {
                    zoom: false,
                },
            });
        });
    }
}


